// A randevu card has a fixed-size note block: a long note is cut at a character
// limit and the card points to "Detayları Görüntüle" instead of growing. The
// full text is always in the details view. Byte-identical in
// dijipo-mobile/utils/appointmentNote.ts — change both.
export const APPOINTMENT_NOTE_PREVIEW_CHARS = 70;

export function appointmentNotePreview(raw: string | null | undefined): { text: string; truncated: boolean } {
  // Collapse line breaks and runs of spaces: a note with many short lines would
  // otherwise overflow the block while still being under the character limit.
  const flat = (raw ?? '').replace(/\s+/g, ' ').trim();
  if (flat.length <= APPOINTMENT_NOTE_PREVIEW_CHARS) return { text: flat, truncated: false };
  return { text: `${flat.slice(0, APPOINTMENT_NOTE_PREVIEW_CHARS).trimEnd()}…`, truncated: true };
}

export const APPOINTMENT_NOTE_MORE_HINT = 'Devamı için Detayları Görüntüle';
